export const LOCALES = [
    'en',
    'es',
    'de',
    'ca',
    'fr',
    'it',
    'pt',
    'da',
];
export const REGIONAL_LOCALES = [
    'en_GB',
    'es_ES',
    'ca_ES',
    'de_DE',
    'fr_FR',
    'fr_BE',
    'it_IT',
    'pt_PT',
    'da_DK',
];
export const REGIONS_LOCALES = {
    en: 'en_GB',
    es: 'es_ES',
    de: 'de_DE',
    ca: 'ca_ES',
    fr: 'fr_FR',
    it: 'it_IT',
    pt: 'pt_PT',
    da: 'da_DK',
    de_ch: 'de_CH',
    fr_ch: 'fr_CH',
    it_ch: 'it_CH',
};
